import React from 'react';
import RedirectToLegacyRouting from '@atlassian/jira-spa-apps-common/src/redirect/legacy-routing/index.tsx';

/** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
const RedirectToLegacyRoutingWrapper = (): React.JSX.Element => <RedirectToLegacyRouting />;

export default RedirectToLegacyRoutingWrapper;
